<script setup>
import { Preview, Radio, Suggestions } from '@components'
import DarkModeStore from '@o/store'
import { computed } from 'vue'
const { options } = DarkModeStore()

const animations = wp_dark_mode_admin_json.default.animation.name.options

const animationName = computed(() => {
    return options.animation_name.toLowerCase().replace(/\s/g, '-')
})

</script>

<template>
    <Row transparent gap="5">
        <Row gap="1">
            <Row space>
                <Toggle v-model="options.animation_enabled">{{__('Enable Page Transition Animation', 'wp-dark-mode')}}</Toggle>
                <Hints>{{__('Enable this option to choose the transition animation when switching between light and dark modes on your website.', 'wp-dark-mode')}}</Hints>
            </Row>
            <div class="flex w-full justify-between gap-6 pr-3 sm:pr-8" v-if="options.animation_enabled">
                <Row borderless space class="w-full">
                    <Heading>{{__('Select Animation', 'wp-dark-mode')}}</Heading>
                    <Card class="w-full max-w-xs" dark>
                        <Radio :options="animations" v-model="options.animation_name"></Radio>
                    </Card>
                </Row>
                <Preview dark size="lg" data-wp-dark-mode-active :data-wp-dark-mode-animation="animationName">
                </Preview>
            </div>
        </Row>
        <Suggestions :paths="{
        'switch': {
            path: '/switch',
            scroll: '#switch-animation',
            name: __('Switch Attention Effect', 'wp-dark-mode'),
        } } " />
    </Row>
</template>